export default "__VITE_ASSET__Ujize6FH__"